/* ds-notify-bis.js — "Wieder-da" Notify-Box.
   Toggelt Sichtbarkeit bei Variantenwechsel (variant:change + Select-Fallback),
   sendet die Anmeldung per AJAX an den ds-bis Worker. ES5-Stil wie das Theme.

   Turnstile-Handling (Fix 2026-06-19):
   - Cloudflare-Turnstile-Token sind EINMALIG (single-use) und laufen nach ~5 Min ab.
   - Frueher: Token wurde einmal erzeugt und bei jedem Submit wiederverwendet
     -> 2. Anmeldung pro Seitenaufruf (anderer Variant / Retry) sendete ein verbrauchtes
        Token -> Worker 403 captcha_failed -> Endlos-Fehler "Seite neu laden".
   - Jetzt: implizites Turnstile-Render (interaction-only, erzeugt zuverlaessig ein Token
     im versteckten Feld). Pro Submit wird auf ein vorhandenes Token gewartet; NACH jedem
     Versuch turnstile.reset() -> das Widget erzeugt automatisch ein FRISCHES Token, damit
     der naechste Submit (anderer Variant / Retry) wieder sauber durchgeht. */
(function () {
  'use strict';

  var EMAIL_RE = /^[^\s@]+@[^\s@]+\.[^\s@]{2,}$/;

  function ready(fn) {
    if (document.readyState !== 'loading') { fn(); }
    else { document.addEventListener('DOMContentLoaded', fn); }
  }

  function initWidget(root) {
    if (root.__bisInit) { return; }
    root.__bisInit = true;

    var form = root.querySelector('[data-bis-form]');
    var msg = root.querySelector('[data-bis-msg]');
    var submitBtn = root.querySelector('[data-bis-submit]');
    if (!form || !submitBtn) { return; }
    var emailEl = form.querySelector('input[name="email"]');
    var consentEl = form.querySelector('input[name="consent"]');
    var endpoint = (root.getAttribute('data-bis-endpoint') || '').replace(/\/+$/, '');

    var state = {
      variantId: root.getAttribute('data-variant-id'),
      variantTitle: root.getAttribute('data-variant-title'),
      available: root.getAttribute('data-variant-available') === '1'
    };

    function setVisible(vis) {
      root.classList.toggle('is-visible', !!vis);
      root.setAttribute('aria-hidden', vis ? 'false' : 'true');
    }
    function updateVariantLabels() {
      var els = root.querySelectorAll('[data-bis-variant]');
      for (var i = 0; i < els.length; i++) { els[i].textContent = state.variantTitle || ''; }
    }
    function showMsg(text, kind) {
      msg.hidden = false;
      msg.textContent = text;
      msg.className = 'ds-bis__msg ' + (kind === 'success' ? 'is-success' : (kind === 'error' ? 'is-error' : ''));
    }
    function storageKey() {
      return 'ds_bis_' + root.getAttribute('data-product-handle') + '_' + state.variantId;
    }
    function refreshDone() {
      try {
        if (localStorage.getItem(storageKey())) {
          root.classList.add('is-done');
          showMsg('Du stehst schon auf der Liste fuer diesen Artikel. Wir melden uns, sobald er wieder da ist.', 'success');
        } else {
          root.classList.remove('is-done');
        }
      } catch (e) { /* localStorage blocked */ }
    }

    // ---- Turnstile (implizites Render erzeugt das Token im versteckten Feld) ----
    function turnstileField() { return form.querySelector('[name="cf-turnstile-response"]'); }
    function currentToken() { var el = turnstileField(); return el ? (el.value || '') : ''; }
    // Wartet, bis ein (frisches) Token vorliegt. Resolved '' wenn Turnstile gar nicht
    // konfiguriert ist (Worker entscheidet dann fail-closed) oder nach ~8s Timeout.
    function awaitToken() {
      return new Promise(function (resolve) {
        if (!turnstileField() && !window.turnstile) { resolve(''); return; }
        var v = currentToken();
        if (v) { resolve(v); return; }
        var tries = 0;
        var iv = setInterval(function () {
          tries++;
          var cur = currentToken();
          if (cur || tries >= 40) { clearInterval(iv); resolve(cur); }
        }, 200);
      });
    }
    // Macht das genutzte Token ungueltig -> Widget erzeugt automatisch ein neues.
    function resetTurnstile() {
      if (window.turnstile) { try { window.turnstile.reset(); } catch (e) {} }
    }
    // Wartet auf ein FRISCHES Token (ungleich dem zuletzt verbrauchten) nach einem reset().
    function awaitFreshToken(prev) {
      return new Promise(function (resolve) {
        if (!turnstileField() && !window.turnstile) { resolve(''); return; }
        var tries = 0;
        var iv = setInterval(function () {
          tries++;
          var cur = currentToken();
          if ((cur && cur !== prev) || tries >= 40) { clearInterval(iv); resolve(cur); }
        }, 200);
      });
    }

    setVisible(!state.available);
    updateVariantLabels();
    refreshDone();

    function onVariant(v) {
      if (!v) { return; }
      if (v.id != null) { state.variantId = String(v.id); }
      if (v.title != null) { state.variantTitle = v.title; }
      state.available = !!v.available;
      updateVariantLabels();
      setVisible(!state.available);
      msg.hidden = true; msg.textContent = '';
      refreshDone();
    }

    document.addEventListener('variant:change', function (e) {
      if (e.detail && e.detail.variant) { onVariant(e.detail.variant); }
    });

    // Fallback: native Varianten-Select (no-JS Pfad / aeltere Themes)
    document.addEventListener('change', function (e) {
      var t = e.target;
      if (!t || t.tagName !== 'SELECT') { return; }
      if (!t.matches('[data-product-select], [name="id"]')) { return; }
      var opt = t.options[t.selectedIndex];
      if (!opt) { return; }
      var label = (opt.textContent || '').trim();
      var dash = label.indexOf(' - ');
      if (dash > -1) { label = label.slice(0, dash).trim(); } // Preis-Suffix abschneiden
      onVariant({ id: opt.value, available: !opt.disabled, title: label || state.variantTitle });
    });

    form.addEventListener('submit', function (ev) {
      ev.preventDefault();

      var hp = form.querySelector('input[name="company"]');
      if (hp && hp.value) { return; } // Honeypot

      var email = (emailEl.value || '').trim().toLowerCase();
      if (!EMAIL_RE.test(email)) {
        showMsg('Bitte pruefe deine E-Mail-Adresse und versuch es nochmal.', 'error');
        emailEl.focus();
        return;
      }
      if (!consentEl.checked) {
        showMsg('Bitte bestaetige die Einwilligung, dann tragen wir dich ein.', 'error');
        return;
      }

      var orig = submitBtn.textContent;
      submitBtn.disabled = true;
      submitBtn.textContent = '...';
      function restoreBtn() { submitBtn.disabled = false; submitBtn.textContent = orig; }

      function send(token) {
        var payload = {
          email: email,
          consent: true,
          consent_version: root.getAttribute('data-bis-consent-version'),
          product_id: root.getAttribute('data-product-id'),
          product_handle: root.getAttribute('data-product-handle'),
          product_title: root.getAttribute('data-product-title'),
          variant_id: state.variantId,
          variant_title: state.variantTitle,
          source_url: location.href,
          locale: document.documentElement.lang || '',
          turnstile_token: token
        };
        return fetch(endpoint + '/bis/subscribe', {
          method: 'POST',
          headers: { 'Content-Type': 'application/json' },
          body: JSON.stringify(payload)
        }).then(function (r) {
          return r.json().catch(function () { return {}; }).then(function (d) {
            return { status: r.status, body: d || {} };
          });
        });
      }

      function isCaptchaFail(res) {
        var e = res && res.body && res.body.error;
        return res && res.status === 403 && (e === 'captcha_failed' || e === 'captcha_unconfigured');
      }

      function handleResult(res) {
        var s = res.body.status;
        var err = res.body.error;
        if (res.status === 200 && (s === 'subscribed' || s === 'pending' || s === 'already' || s === 'ok')) {
          try { localStorage.setItem(storageKey(), String(Date.now())); } catch (e) {}
          root.classList.add('is-done');
          var title = root.getAttribute('data-product-title') || 'der Artikel';
          if (s === 'already') {
            showMsg('Du stehst schon auf der Liste fuer diesen Artikel. Wir melden uns, sobald er wieder da ist.', 'success');
          } else if (s === 'pending') {
            showMsg('Fast geschafft. Bitte bestaetige kurz die E-Mail, die wir dir gerade geschickt haben.', 'success');
          } else {
            showMsg('Passt, wir melden uns per E-Mail, sobald ' + title + ' wieder da ist.', 'success');
          }
          return;
        }
        if (res.status === 429) {
          showMsg('Zu viele Versuche. Bitte versuch es in ein paar Minuten nochmal.', 'error');
        } else if (err === 'captcha_failed' || err === 'captcha_unconfigured' || err === 'captcha_unavailable') {
          showMsg('Sicherheitspruefung lief nicht durch. Tippe einfach nochmal auf Eintragen.', 'error');
        } else if (err === 'invalid_input' || err === 'consent_required') {
          showMsg('Bitte pruefe deine Eingaben und versuch es nochmal.', 'error');
        } else {
          showMsg('Das hat gerade nicht geklappt. Versuch es bitte in einem Moment nochmal.', 'error');
        }
      }

      // Token holen -> senden. Bei captcha_failed EINMAL transparent mit frischem Token
      // erneut versuchen (Self-Heal gegen verbrauchte/abgelaufene Token), erst dann melden.
      awaitToken().then(function (token) {
        return send(token).then(function (res) {
          if (!isCaptchaFail(res)) { return res; }
          resetTurnstile();
          return awaitFreshToken(token).then(function (t2) { return send(t2); });
        });
      }).then(handleResult).catch(function () {
        showMsg('Das hat gerade nicht geklappt. Versuch es bitte in einem Moment nochmal.', 'error');
      }).then(function () {
        // Immer: Button zuruecksetzen + frisches Token fuer den naechsten Versuch holen.
        restoreBtn();
        resetTurnstile();
      });
    });
  }

  ready(function () {
    var widgets = document.querySelectorAll('[data-bis-widget]');
    for (var i = 0; i < widgets.length; i++) { initWidget(widgets[i]); }
  });
})();
